import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IOrganizationsState, IOrganizationInstance } from './organizations.reducer';
import { selectCurrentShare } from '../share/models/share.selector';

export const selectOrganizations = createFeatureSelector('organizations');

export const selectAllOrganizations = createSelector(
  selectOrganizations,
  (organizations: IOrganizationsState) => {
    if (organizations
      && organizations.entities
      && organizations.entities.organizations
    ) {
      return Object.values(organizations.entities.organizations);
    }
  }
);

export const getSelectedOrganizationId = createSelector(
  selectOrganizations,
  (organizations: IOrganizationsState) => {
    if(organizations && organizations.selectedOrganizationId) {
      return organizations.selectedOrganizationId;
    }
  }
)

export const getSelectedOrganization = createSelector(
  selectAllOrganizations, getSelectedOrganizationId,
  (organizations: IOrganizationInstance[], selectedOrganizationId: string) => {
    if(organizations && selectedOrganizationId) {
      return organizations.find((organization) => organization.globalId == selectedOrganizationId);
    } else {
      return null;
    }

  }
)

export const getIsOrganizationsFetched = createSelector(
  selectOrganizations,
  (organizations: IOrganizationsState) => {
    return !organizations.isFetching;
  }
)

export const getCurrentOrganization = createSelector(
  selectOrganizations,
  (organizations: IOrganizationsState) => {
    if(organizations.currentOrganization !== undefined) return organizations.currentOrganization;
  }
)

export const selectShareOrganization = createSelector(
  selectAllOrganizations, selectCurrentShare,
  (organizations, share) => {
    if(organizations && organizations.length && share.instance && share.instance.org) {
      return organizations.find((org) => org.title == share.instance.org.title)
    } else {
      return null;
    }
  }
)
